export enum CurrencyCode {
  CAD = 'CAD',
  USD = 'USD'
}

export enum CurrencyCodeByCountry {
  CA = CurrencyCode.CAD,
  US = CurrencyCode.USD,
  XX = CurrencyCode.USD,
  OTHER = CurrencyCode.USD
}
